import { api } from './api';

export interface Brand {
  name: string;
  sub: string;
  tagline: string;
  logo_url: string;
  brand_color: string;
  favicon: string;
}

export const DEFAULT_BRAND: Brand = {
  name: 'WIREDESK',
  sub: 'OS',
  tagline: 'Sala de controlo editorial',
  logo_url: '',
  brand_color: '',
  favicon: '',
};

export const brandService = {
  // Public — works without a token (login/boot read it before auth).
  get: (): Promise<Brand> => api.get<Brand>('/brand'),
  // Admin.
  update: (patch: Partial<Brand>): Promise<Brand> => api.put<Brand>('/brand', patch),
};
